// removed by extract-text-webpack-plugin
module.exports = {"root":"Rules__root___tE-YC","loginForm":"Rules__loginForm___Hjq49","title":"Rules__title___1WzfP","label":"Rules__label___37tF2","button":"Rules__button___36cBh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Rules/Rules.scss
// module id = 976
// module chunks = 0